const landingPageSelector = "#rt-collective-landing-page";

if (document.querySelector(landingPageSelector)) {
	void import("./index.js").then((e) => e.default());
}
